import { proxy } from 'valtio';

export const unitsOfCompetencyState = proxy({
  isSettingsDrawerOpen: false,
  openSettingsDrawer: () => {
    unitsOfCompetencyState.isSettingsDrawerOpen = true;
  },
  closeSettingsDrawer: () => {
    unitsOfCompetencyState.isSettingsDrawerOpen = false;
  },
});
